import { promiseAction } from 'utils/store';

export const RADAR_ACTION_TYPES = {
  LOAD_RADAR_RANGES: 'radar/LOAD_RADAR_RANGES',
  CREATE_RADAR_RANGES: 'radar/CREATE_RADAR_RANGES',
  DELETE_RADAR_RANGES: 'radar/DELETE_RADAR_RANGES',
};

export const loadRadarRanges = promiseAction(RADAR_ACTION_TYPES.LOAD_RADAR_RANGES);

export const deleteRadarRanges = promiseAction(RADAR_ACTION_TYPES.DELETE_RADAR_RANGES);

export const createRadarRanges = promiseAction(RADAR_ACTION_TYPES.CREATE_RADAR_RANGES);